const documentLink = require('./documentLink');
const documentTypeToIcon = require('./documentTypeToIcon');
const documentTypeDescription = require('./documentTypeDescription');

module.exports = function documentPresenter(doc) {
    const view = require('./documentPresenter.tpl.html');
    const c = {};

    c.activate = function(region) {
        view.activate(region);
        view.document.href = documentLink(doc.id);
        view.documentIcon.classList.add(documentTypeToIcon(doc.documentType));
        view.documentType.innerText = documentTypeDescription(doc.documentType);
    };

    c.deactivate = function() {
        view.deactivate();
    };
    return c;
};
